import { defineMessages } from 'react-intl';

export default defineMessages({
    profile: {
        id: 'tdic.endorsement.profile-change.Profile',
        defaultMessage: 'Profile'
    },
    prefix: {
        id: 'tdic.endorsement.profile-change.Prefix',
        defaultMessage: 'Prefix'
    },
    firstName: {
        id: 'tdic.endorsement.profile-change.First Name',
        defaultMessage: 'First Name'
    },
    lastName: {
        id: 'tdic.endorsement.profile-change.Last Name',
        defaultMessage: 'Last Name'
    },
    suffix: {
        id: 'tdic.endorsement.profile-change.Suffix',
        defaultMessage: 'Suffix'
    },
    dateOfBirth: {
        id: 'tdic.endorsement.profile-change.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    primaryPhone: {
        id: ' tdic.endorsement.profile-change.Primary Phone',
        defaultMessage: 'Primary Phone'
    },
    homePhone: {
        id: 'tdic.endorsement.profile-change.Home Phone',
        defaultMessage: 'Home Phone'
    },
    workPhone: {
        id: 'tdic.endorsement.profile-change.Work Phone',
        defaultMessage: 'Work Phone'
    },
    mobilePhone: {
        id: 'tdic.endorsement.profile-change.Mobile Phone',
        defaultMessage: 'Mobile Phone'
    },
    faxPhone: {
        id: 'tdic.endorsement.profile-change.Fax Phone',
        defaultMessage: 'Fax Phone'
    },
    emailAddress: {
        id: 'tdic.endorsement.profile-change.Email Address',
        defaultMessage: 'Email Address'
    },
    submit: {
        id: 'tdic.endorsement.profile-change.Submit',
        defaultMessage: 'Submit'
    },
    back: {
        id: 'tdic.endorsement.profile-change.Back',
        defaultMessage: 'Back'
    },
    updatePreference: {
        id: 'tdic.endorsement.profile-change.Please review and update the phone , email and paperless preference below.',
        defaultMessage: 'Please review and update the phone , email and paperless preference below.'
    },
    preferredPolicy: {
        id: 'tdic.endorsement.profile-change.Email and Phone numbers will be used for correspondence related to all of your policies.',
        defaultMessage: 'Email and Phone numbers will be used for correspondence related to all of your policies.'
    },
    paperlessPreferredPolicy: {
        id: 'tdic.endorsement.profile-change.Paperless preference determines your document delivery method for this policy only.',
        defaultMessage: 'Paperless preference determines your document delivery method for this policy only.'
    },
    paperlessPreferredTooltip: {
        id: 'tdic.endorsement.profile-change.Select YES for paperless preferred to receive an email notification so that you can view your documents anytime at your convenience.',
        defaultMessage: 'Select YES for paperless preferred to receive an email notification so that you can view your documents anytime at your convenience.'
    },
    officePhone: {
        id: 'tdic.endorsement.profile-change.Office Phone',
        defaultMessage: 'Office Phone'
    }
});
